<h2 mat-dialog-title>{{'contentTypes.schemaItemValidator' | translate}}</h2>
<mat-dialog-content>
    <section class="validator-dialog-intro">
      <span>{{getRuleLabel()}}</span>
      <p>{{getRuleDescription()}}</p>
    </section>
    <form [formGroup]="ruleForm" class="m-1 validator-form">
        @if(data.ruleStructure && data.ruleStructure.parameters){
                @for( rule of data.ruleStructure.parameters; track rule; let index = $index){
                    @if(rule.inputType == 'textarea'){
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{getParameterLabel(rule)}}</mat-label>
                            <textarea matInput [formControlName]="rule.key" [placeholder]="getParameterPlaceholder(rule)" rows="4"></textarea>
                            <mat-hint>{{getParameterHint(rule)}}</mat-hint>
                        </mat-form-field>
                    }

                    @if(rule.inputType == 'format'){
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{getParameterLabel(rule)}}</mat-label>
                            <mat-select [formControlName]="rule.key">
                                @for(option of formatOptions; track option){
                                    <mat-option [value]="option">{{option}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }

                    @if(rule.inputType != 'boolean' && rule.inputType != 'textarea' && rule.inputType != 'format' && rule.key != 'decimal'){
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{getParameterLabel(rule)}}</mat-label>
                            @if(rule.inputType == 'datetime-local'){
                                <input matInput type="{{rule.inputType}}" formControlName="{{rule.key}}" max="9999-12-31T23:59" min="1970-01-01T00:00"/>
                            }

                            @if(rule.inputType != 'datetime-local'){
                                <input matInput type="{{rule.inputType}}" formControlName="{{rule.key}}" [placeholder]="getParameterPlaceholder(rule)" />
                            }
                            @if(getParameterHint(rule)){
                                <mat-hint>{{getParameterHint(rule)}}</mat-hint>
                            }
                        </mat-form-field>
                    }

                    @if(rule.key == 'decimal' || rule.inputType == 'boolean'){
                        <div class="form-control mb-1 d-flex justify-content-between align-items-center p-3">
                            <label [for]="rule.key">{{getParameterLabel(rule)}}</label>
                            <mat-slide-toggle [id]="rule.key" [formControlName]="rule.key"></mat-slide-toggle>
                        </div>
                    }
                }

        }
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{'taskTemplates.rules.errorMessage_description' | translate}}</mat-label>
                <input matInput type="text" formControlName="errorMessage" />
                <mat-hint>{{'taskTemplates.rules.errorMessage_hint' | translate}}</mat-hint>
            </mat-form-field>
    </form>
    @if(validationErrorKey; as errorKey){
      <p class="validator-error" role="alert">{{errorKey | translate}}</p>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="[false]" style="color:var(--warmOrange);">{{'cancel' | translate}}</button>
  <button mat-button class="orange-button" (click)="saveRule()" [disabled]="!tasktemplateUserRights_update || !!validationErrorKey" cdkFocusInitial>{{'apply' | translate}}</button>
</mat-dialog-actions>

